<template>
    <div style="margin: 10px;">
        
        <ul v-if="reading != null" class="nav nav-tabs sup-tabs" style="margin-bottom: 7px;">
          <li :class="{'active': subAnteprima}" style="float: right;"><a href="#" @click.prevent="subAnteprima = true">{{$Jed.firstUpperTranslate('preview', null)}}</a></li>
          <li :class="{'active': !subAnteprima}" style="float: right;"><a href="#" @click.prevent="subAnteprima = false">{{$Jed.firstUpperTranslate('documents list', null)}}</a></li>
        </ul>
        <div id="scroll-thumb" class="doc-container" style="width: 100%; text-align: right; overflow-y: auto;" :style="{'max-height': maxh ? maxh + 'px' : 'unset'}">
            
            <!-- TAB LISTA DOCUMENTI -->
            <div v-if="reading == null || !subAnteprima">
                <div v-for="doc in documents" class="thumbnail" @click.prevent="read(doc)"
                    :class="{'active': reading != null && doc.na == reading.na}"
                    v-if="ready && documents && documents.length > 0">
                    <a href="#">
                        <div class="caption">
                            <button class="btn btn-sm"><i :class="$root.icons.download" @click.stop="download(doc)" style="margin-left: 0px;"></i></button>
                            <p v-if="$Behaviors.useClientDocumentType">{{doc.documentType}}</p>
                            <p v-else>{{doc.filename + '.pdf'}}</p>
                        </div>
                        <div class="embed-responsive embed-responsive-4by3 bg-cover" style="width: 100%;" 
                            :style="getTabDocStyle(doc)"></div>
                    </a>
                </div>
                <div v-if="ready && documents.length == 0" style="text-align: center; padding-top: 10px;">
                    <span>{{$Jed.firstUpperTranslate('no document available', null)}}</span>
                </div>
            </div>
            <!-- TAB ANTEPRIME DOCUMENTO -->
            <div v-else>
                <div v-for="p in previews" class="thumbnail" :class="{'active': readingPage == p.page}">
                    <a href="#" @click="readPage(p.page)">
                        <div class="caption">
                            <p>{{p.page}}</p>
                        </div>
                        <div class="embed-responsive embed-responsive-4by3 bg-cover" style="width: 100%;" 
                        :style="getStyle(p)"></div> 
                    </a>
                </div>
                <div v-if="!previews || previews.length == 0" style="text-align: center; padding-top: 10px;">
                    <span>{{$Jed.firstUpperTranslate('no preview available', null)}}</span>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

import { eventBus } from "../../eventbus";

    export default {
        props: {
            activeData: {
                type: Object,
                default: null
            },
            mh: Number
        },
        mounted: function(){
            this.maxh = this.mh;
            
            //se devo vedere solo i tipi documento destinati a quel cliente
            if(this.$Behaviors.useClientDocumentType){
                this.documentTypesColl = this.$root.dbRegistry.getCollection('documentTypes');
            }

            if(this.activeData != null){
                this.loadDocuments();
            }
            try {  
                var def = this.$root.supportDefaults.Documenti;
                this.$root.sup_apply(null, null, null, def);
            } catch(err){}
            
        },
        created: function(){
            var vm = this;
            eventBus.$on("read_pdf_page", function(p){
                vm.readingPage = p;
            })
            eventBus.$on("unloadDocument", function(){
                vm.reading = null;
                vm.readingPage = null
            })
            this.$nextTick(function(){
                var vm = this;
                eventBus.$on("newSupportSide", function(size){
                    vm.$root.supportDefaults.Documenti = size;
                })
            })
        },
        beforeDestroy: function(){
            eventBus.$off("newSupportSide")
        },
        data: function(){
            return {
                activeOne: null,
                documents: null,

                reading: null,
                readingPage: null,

                previews: [],
                subAnteprima: true,
                ready: false,

                maxh: null,
                documentTypesColl: []
            }
        },
        watch: {
            activeData: function(){
                if(this.activeData != null){
                    this.loadDocuments();
                }
            },
            mh: function(){
                this.maxh = this.mh;
            },
            reading: function(){
                if(this.reading != null){
                    this.maxh = this.mh - 50;
                } else {
                    this.maxh = this.mh;
                    this.previews = []
                }
            }
        },
        methods: {
            getStyle(p){
                var obj = {}
                obj["background-image"] = "url(\""+p.prev+"\")"
                return obj;
            },
            getFigure4: function(n){
                n = n.toString();
                var figures = n.length;
                var res = "";
                for(var i = 0; i < 4-figures; i++){
                    res += "0"
                }
                res += n;
                return res;
            },
            getPage: function(name, npage, ntot){
                return name + "_p" + this.getFigure4(npage) + "-" + this.getFigure4(ntot);
            },
            loadDocuments: function(){                
                this.activeOne = this.activeData.father;                
                this.ready = false;
                
                this.$root
                .microservice({
                    role: "catalog",
                    cmd: "SearchById",
                    params: {
                        sid: this.activeOne.sid,
                        labels: [],
                        prod_info: ["doc"]
                    }
                })
                .then(
                    response => {
                        var res = response.body;
                        try {
                            res = JSON.parse(response.body);
                        } catch (err) {}

                        this.documents = [];
                        if (res.answer && res.answer.length > 0) {
                            var prod = res.answer[0];
                            if(prod.doc && prod.doc.length > 0){
                                for(var i = 0; i < prod.doc.length; i++){
                                    var d = prod.doc[i];
                                    var fname =  d.na.split(".");
                                    d.ext = fname.pop();
                                    d.filename = fname.join(".");
                                    if(typeof d.np == 'number' && d.np>0){
                                        d.preview = this.getPage(d.filename, 1, d.np) + "_tn.jpg";
                                    }else{
                                        d.preview = d.filename + "_tn.jpg";
                                    }

                                    if(this.$Behaviors.useClientDocumentType){
                                        var docType = this.documentTypesColl.find({'id': d.tyd})[0];
                                        console.log(docType)
                                        d.documentType = docType.des[this.$root.token.siglaLingua] ? docType.des[this.$root.token.siglaLingua] : docType.des[this.$root.token.defaultLang]
                                    }

                                    this.documents.push(d);
                                }
                            }
                        }
                        var vm = this;
                        eventBus.$emit("pdf_exists", function(r){
                            var itsHis = vm.documents.some(function(d){
                                if(d.filename == r.reading.filename){
                                    return true;
                                }
                                return false;
                            })
                            
                            if(itsHis){
                                vm.reading = r.reading;
                                vm.readingPage = r.readingPage;
                                vm.elabPreviews();
                            } else {
                                vm.reading = null;
                            }
                        })
                        this.ready = true;
                        
                    },
                    err => {
                        this.ready = true;
                        //vedi gestione errore in main.js > microservice
                    }
                )
                .catch(err => {
                    console.log(err);
                    var msg = err && err.body && err.body.error ? err.body.error : ''
                    eventBus.$emit('alert', {
                        message: "Application caught an error <br> <h5>Details: " + "catalog.SearchById - " + msg +'</h5>',
                        type: "error",
                        action: ''
                    })
                })
            },
            elabPreviews: function(){
                if(this.reading != null){
                    this.previews = [];
                    if(this.reading.np){
                        for(var i = 1; i <= this.reading.np; i++){
                            var obj = {
                                page: i,
                                prev: this.$root.msPath + '/'+ this.$Configs.licenseId +'/doc/pag/' + this.reading.filename + '/' + this.getPage(this.reading.filename, i, this.reading.np) + '_tn.jpg'
                            }
                            this.previews.push(obj)
                        }
                    }
                }
            },
            read: function(obj){
                console.log(obj.filename)
                if(typeof obj.np == 'number' && obj.np>0){
                    eventBus.$emit("changeView", "ImgLayout")
                    this.$nextTick(function(){
                        this.$nextTick(function(){
                            this.reading = obj;
                            this.elabPreviews();
                            eventBus.$emit("read_pdf",{d:obj})
                        })
                    })
                }else{
                    //non ci sono le pagine quindi è un documento non convertito, lo cerco nella cartella doc/src
                    if(obj.na && !obj.na.startsWith('missing')){
                        window.open(this.$root.msPath + '/'+ this.$Configs.licenseId +'/doc/src/' + obj.na);
                    }else{
                        alert('document missing!')
                    }
                }
            },
            readPage: function(page){
                eventBus.$emit("go_to_page", page);
            },
            download: function(obj){
                window.open(this.$root.msPath + '/'+ this.$Configs.licenseId +'/doc/src/' + obj.filename + '.pdf');
            },
            getTabDocStyle: function(doc){
                var obj = {}
                if(typeof doc.np == 'number' && doc.np>0){
                    obj["background-image"] = "url('"+ this.$root.msPath + '/' + this.$Configs.licenseId + '/doc/pag/' + doc.filename + '/' + doc.preview +"')"
                }else{
                    obj["background-image"] = "url('"+ this.$root.msPath + '/' + this.$Configs.licenseId + '/doc/tn/'  + doc.preview +"')"
                }
                return obj;
            }
        }
    }
</script>

<style scoped>
.thumbnail {
    width: 100%;
    max-width: 250px;
    background: transparent;
    display: inline-block;
    margin-bottom: 0px;
}

.thumbnail .caption {
    padding: 2px 5px 8px 5px;
    color: #b8c7ce;
}

.thumbnail .caption > p {
    text-align: right;
    margin: 0px;
}

.thumbnail .caption .btn {
    padding: 4px 6px 3px 6px; 
    line-height: 1.3; 
    float: left;
    border-color: #b8c7ce;
    color: #b8c7ce;
    background-color: transparent;
}

.thumbnail .caption .btn:hover {
    color: #222d32;
    background-color: #b8c7ce;
}

.thumbnail.active .caption .btn {
    border-color: white;
    color: white;
}

.thumbnail.active .caption .btn:hover {
    border-color: white;
    background-color: white;
    color: #017ebc;
}

.thumbnail.active {
    background: #017ebc;
}

.thumbnail.active .caption{
    color: white;
}

.embed-responsive.bg-cover {
    background-position: left 100% 100%;
    -webkit-background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    -o-background-size: 100% 100%;
    background-size: 100% 100%;
    
    background-position: center;
    background-size: cover;
}

</style>


// WEBPACK FOOTER //
// src/components/menu-sup-components/Documenti.vue?5696a74e